import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TextbookClient } from '@textbook-api-client';

import { environment } from '@environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { interceptors } from './core/interceptors';
import { CoreModule } from './core/core.module';
import { appInitializer } from './app-initializer';
import { hammerConfig } from './hammer-config';
import { NoteBoxService } from './textbook/components/note-box/note-box-service';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    HammerModule,
  ],
  providers: [
    appInitializer,
    hammerConfig,
    NoteBoxService,
    ...interceptors,
    {
      provide: TextbookClient,
      useFactory: (http: HttpClient) =>
        new TextbookClient(http, environment.textbookApiUrl, environment.editorPreviewMode),
      deps: [HttpClient],
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
